// lib/onboarding.server.ts (setup-guide step copy) + components/onboarding/
// SetupGuide.tsx + IllustratedEmpty.tsx (shared empty-state card).
export const onboarding = {
  steps: {
    draftQuoteLabel: "Draft your first quote",
    draftQuoteDescription: "Pick a B2B company, drop in line items, save as draft.",
    sendQuoteLabel: "Send a quote to a buyer",
    sendQuoteDescription: "The buyer gets a signed email link to view, accept, or decline.",
    acceptQuoteLabel: "Get a quote accepted",
    acceptQuoteDescription: "When the buyer clicks Accept on the email, we capture the timestamp.",
    convertDraftOrderLabel: "Convert to a Shopify draft order",
    convertDraftOrderDescription:
      "Acceptance auto-creates a B2B draft order with the right purchasing entity.",
    shopifyDraftsLinkLabel: "Shopify Drafts",
  },
  setupGuide: {
    allDoneHeading: "You're all set 🎉",
    allDoneBody:
      "You've finished every setup step — nice work. When you're ready, explore advanced features like PO parsing and AI counter-offers.",
    seeEverythingLink: "See everything Quote Desk can do →",
    heading: "Set up Quote Desk",
    stepsComplete: "{{completed}} of {{total}} steps complete",
    autoCompleteHint: "Each step completes automatically as you use the app. New here?",
    seeHowItWorksLink: "See how it works",
    openLink: "Open",
  },
};
